/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_CarrierInputs */

const en_orders_carrier = /** @type {(inputs: Orders_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier`)
};

const es_orders_carrier = /** @type {(inputs: Orders_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transportista`)
};

/**
* | output |
* | --- |
* | "Carrier" |
*
* @param {Orders_CarrierInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier = /** @type {((inputs?: Orders_CarrierInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_CarrierInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier(inputs)
	return es_orders_carrier(inputs)
});